import React from 'react';

export const MonkeyLogo = ({ size = 32, className = '' }) => (
  <img 
    src="/mascot.png"
    alt="LinkMonkey"
    width={size} 
    height={size}
    className={className}
    style={{ objectFit: 'contain' }}
  />
);

export const MonkeyIcon = ({ size = 20, className = '' }) => (
  <img 
    src="/mascot.png"
    alt="LinkMonkey"
    width={size} 
    height={size}
    className={className}
    style={{ objectFit: 'contain' }}
  />
);
